/*
 * FSF Responsive JS
 */

(function($) {

    var $parent_container;

    $(document).ready(function() {
        bindEvents();
        setStickyAreas();
        $parent_container = $('.entry').eq(0).parent();
    });

    function bindEvents() {
        if (window.innerWidth < 1061) {
            removeUberSubmenu();
            bindSearchBar();
        }

        updateAllLinks();

        $('.ajax-load-more button').on('click', loadMorePosts);

        uberMenuToggle();
    }

    function loadMorePosts() {
        var button = $(this),
            data = {
            'action': 'fsf_ajax_loadmore',
            'query': fsf_responsive_params.posts, // that's how we get params from wp_localize_script() function
            'page' : fsf_responsive_params.current_page,
            'nonce': fsf_responsive_params.ajax_nonce,
            'is_responsive' : fsf_responsive_params.is_responsive
        };

        if (button.hasClass('loading')) {
            return;
        }

        $.ajax({ // you can also use $.post here
            url : fsf_responsive_params.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            beforeSend : function ( xhr ) {
                button.find('.label').text('Loading...'); // change the button text, you can also add a preloader image
                button.addClass('loading');
            },
            success : function( data ){
                if( data ) { 
                    button.find('.label').text( fsf_responsive_params.load_more_text );
                    button.removeClass('loading');
                    $parent_container.append(data);
                    fsf_responsive_params.current_page++;
                    //button.parent().before(data);

                    if ( fsf_responsive_params.current_page == fsf_responsive_params.max_page ) 
                        button.parent().remove(); // if last page, remove the button

                    // you can also fire the "post-load" event here if you use a plugin that requires it
                    // $( document.body ).trigger( 'post-load' );
                } else {
                    button.parent().remove(); // if no data, remove the button as well
                }
            }
        });
    }

    function setStickyAreas() {

        var $el_bottom = $('.sticky-ad-bottom');
        if ( $el_bottom.length && $el_bottom.is(":visible") ) {
            var html = "<div class=\"sticky-placeholder-bottom\"></div>";
            var height = $el_bottom.outerHeight();
            console.log(height);
            $('body').append( html );
            $('.sticky-placeholder-bottom').height(height + "px");
            //$el_bottom.addClass('sticky-ad-bottom');
        }

        var $el_top = $('.sticky-ad-top');
        if ( $el_top.length && $el_top.is(":visible") ) {
            var html = "<div class=\"sticky-placeholder-top\"></div>";
            var height = $el_top.outerHeight();
            $('body').prepend( html );
            $('.sticky-placeholder-top').height(height + "px");
            //$el_top.addClass('sticky-ad-top');
        }

    }

    /**
     * Update all internal links with mobile-wv-param
     */
     function updateAllLinks() {

        //var query_param = isNativeView ? nativeview_param : webview_param;
        var query_param = fsf_responsive_params.param;

        $('a').each(function() {
            var urlhost = $(this)[0].hostname;
            urlhost = getParentDomain(urlhost);
            var host = getParentDomain(window.location.hostname);

            if (host == urlhost) {
                // Let's append all our existing params.
                var url = $(this)[0].href;
                // Get the params of the current page.
                var urlParams = new URLSearchParams(window.location.search);
                var entries = urlParams.entries();
                var newURL = url;
                // Get the param of the link in question.
                var linkURL = new URL(url);
                var linkParams = new URLSearchParams(linkURL.search);
                var linkEntries = linkParams.entries();
                var shouldIgnore = false;
                for(linkPair of linkEntries) {
                    var key = linkPair[0];
                    var value = linkPair[1];
                    if (key == 'ignore-webview') {
                        shouldIgnore = true;
                        break;
                    } 
                }

                if (!shouldIgnore) {
                    for(pair of entries) {
                        var key = pair[0];
                        var value = pair[1];
                        // We want to replace the 'view' param with webview only as it's the only compatible one for deeplinks.
                        if ( (key == fsf_responsive_params.param) ) {
                            key = query_param;
                        }
                        newURL = UpdateQueryString(key, value, newURL);
                    }
                    
                    $(this).attr('href', newURL);
                }
                
            }
        });

    }

    function getParentDomain(domain) {
        var separate = domain.split('.');
        separate.shift();
        return separate.join('.');
    }

    /**
     * Update url with new query param
     * @param {[type]} key   
     * @param {[type]} value 
     * @param {[type]} url   
     */
    function UpdateQueryString(key, value, url) {
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null)
                return url.replace(re, '$1' + key + "=" + value + '$2$3');
            else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
        } else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            } else
                return url;
        }
    }

    function bindSearchBar() {
        // add responsive to our mobile search.
        var responsive_param = $("<input>")
               .attr("type", "hidden")
               .attr("name", fsf_responsive_params.param ).val("true");

        $('.mobile-search .ubermenu-searchform').append(responsive_param);
        $('.search-form-wrapper form.search-form').append(responsive_param);
        // Bind clicks.
        $(document).on('click', '.mobile-search .ubermenu-search-submit', function(e){
            // If it's open already, check if we have a search term...
            if ( $('.mobile-search').hasClass('-search-open') ) {
                var term = $('.mobile-search .ubermenu-search-input').val();
                // If it's already open and we have no term, do nothing, otherwise submit
                if (term === '') {
                    e.preventDefault();
                } 
            } else {
                // if it's not open already, add the class and stop
                e.preventDefault();
                $('.mobile-search').addClass('-search-open');
            }
        });

        $(document).on('click', '.mobile-search.-search-open label', function(e){
            $('.mobile-search').removeClass('-search-open');
            e.preventDefault();
        });
    }

    function uberMenuToggle() {
        $( '.ubermenu-responsive-toggle' ).on( 'ubermenutoggledopen' , function(e){
            $('#header').addClass('-menu-open');
        });

        $( '.ubermenu-responsive-toggle' ).on( 'ubermenutoggledclose' , function(e){
            $('#header').removeClass('-menu-open');
        });
    }

    function removeUberSubmenu() {
        $('.ubermenu-item-has-children').each(function() {
            $(this).replaceClass('ubermenu-item-has-children', 'ubermenu-item-has-children-disabled');
            $(this).replaceClass('ubermenu-advanced-sub', 'ubermenu-advanced-sub-disabled');
            $(this).replaceClass('ubermenu-has-submenu-drop', 'ubermenu-has-submenu-drop-disabled');
            $(this).replaceClass('ubermenu-has-submenu-mega', 'ubermenu-has-submenu-mega-disabled');
        });
    }

    function readdUberSubmenu() {
        
    }
    

})(jQuery);            

/*
 * Let's begin with validation functions
 */
jQuery.extend(jQuery.fn, {
    /*
     * check if field value lenth more than 3 symbols ( for name and comment ) 
     */
    replaceClass: function(find, replace) {
        if (jQuery(this).hasClass(find)) {
            jQuery(this).removeClass(find);
            jQuery(this).addClass(replace);
            return true;
        } else {
            return false;
        }
    }
});